module.exports = {
  dayGridMonth: 'dayGridMonth',
  resourceTimeGridDay: 'resourceTimeGridDay',
  timeGridDay: 'timeGridDay',
  timeGridWeek: 'timeGridWeek',
};
